/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * CreditCardIcon
 */
export default class CreditCardIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 4a4 4 0 014 4v8a4 4 0 01-4 4H5a4 4 0 01-4-4V8a4 4 0 014-4h14zm2 6H3v6a2 2 0 002 2h14a2 2 0 002-2v-6zm-11 4a1 1 0 01.117 1.993L10 16H5a1 1 0 01-.117-1.993L5 14h5zm3 0h1a1 1 0 01.117 1.993L14 16h-1a1 1 0 01-.117-1.993L13 14h1zm6-8H5a2 2 0 00-2 2h18a2 2 0 00-2-2z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

